var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M21.2593,10.89,7.6411,21.6411,5,19,21.8787,5.6747a3.4235,3.4235,0,0,1,4.2426,0L43,19l-2.87,2.46L26.7407,10.89A4.4073,4.4073,0,0,0,21.2593,10.89ZM25.5015,12.46,40,23.9055V44H8V23.9055L22.4985,12.46A2.4169,2.4169,0,0,1,25.5015,12.46ZM29.0123,30H18.9877a1.1035,1.1035,0,0,0-1.0968.9816L17,39H31l-.8909-8.0184A1.1035,1.1035,0,0,0,29.0123,30ZM24,19a4,4,0,1,0,4,4A4,4,0,0,0,24,19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLight);
export default __webpack_public_path__ + "static/media/homeLight.7d66a85f1923a77309d1700a9cd92dff.svg";
export { ForwardRef as ReactComponent };